import { ConnectorPosition } from '../../BrazilMiniMap'

const TOOLTIP_WIDTH = 264

function getRelativeCoordinates(
  group: SVGGElement,
  containerSize: { width: number; height: number },
  tooltipEstimatedHeight = 0
) {
  const bbox = group.getBBox()

  // Anchor the tooltip under the hovered region/label
  const svgX = bbox.x + 0.5 * bbox.width
  const svgY = bbox.y + 0.7 * bbox.height // center-bottom

  const ctm = group.getCTM()
  const svg = group.ownerSVGElement as SVGSVGElement
  const point = svg.createSVGPoint()
  point.x = svgX
  point.y = svgY

  const screenPoint = point.matrixTransform(ctm as DOMMatrix)

  // Default anchor (center horizontal)
  let tooltipLeft = screenPoint.x - TOOLTIP_WIDTH / 2

  // Prevent overflow left
  if (tooltipLeft < 0) {
    tooltipLeft = 8 // 8px padding from left
  }

  // Prevent overflow right
  if (tooltipLeft + TOOLTIP_WIDTH > containerSize.width) {
    tooltipLeft = containerSize.width - TOOLTIP_WIDTH - 8 // 8px padding from right
  }

  const offset = 8

  // If placing tooltip below the point would overflow container height,
  // flip tooltip to appear above the point.
  let placement = ''
  let tooltipTop: number
  if (screenPoint.y + tooltipEstimatedHeight + offset > containerSize.height) {
    // flip vertically above
    tooltipTop = screenPoint.y - tooltipEstimatedHeight - offset
    placement = `bottomCenter`
  } else {
    // default below
    tooltipTop = screenPoint.y + offset
    placement = `topCenter`
  }

  return {
    x: `${tooltipLeft}px`,
    y: `${tooltipTop}px`,
    placement: placement as ConnectorPosition
  }
}

export default getRelativeCoordinates
